import { api } from "@/lib/api";

// A friend's share link (/?ref=CODE) is remembered on this browser so the booking form can apply
// it. The form only trusts it after the server confirms it's a real customer's code — a leftover
// or made-up code (e.g. a test "TESTREF") is dropped, so no banner and no preset answer.
const KEY = "shs_ref";

export const saveReferral = (code) => {
  const c = (code || "").trim().toUpperCase().slice(0, 40);
  if (c) localStorage.setItem(KEY, c);
};

let checking = null; // { code, promise } — one server check per code per page load

const check = async (code) => {
  try {
    const { data } = await api.get(`/referrals/check/${encodeURIComponent(code)}`);
    if (!data?.valid) localStorage.removeItem(KEY);
    return data?.valid ? code : "";
  } catch {
    checking = null; // can't confirm right now — show nothing, keep it for a later try
    return "";
  }
};

// The stored code if it's a real customer's; "" otherwise (and an invalid one is forgotten).
export const verifiedReferral = () => {
  const code = (localStorage.getItem(KEY) || "").trim().toUpperCase();
  if (!code) return Promise.resolve("");
  if (checking?.code !== code) checking = { code, promise: check(code) };
  return checking.promise;
};
